import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormComponent from 'modules/core/components/Form'

import type { Action } from 'modules/automations/store/models/Action'

import { AutomationStep } from '../Step'
import { automationSteps } from '../Step/constants'
import { getActionName } from '../actionUtils'
import Selects from './Selects'

interface Props {
  form: Form | undefined
  onClick?: () => void
  action: Action
  withLastSpacer?: boolean
}

const TimeAction = ({ form, onClick, action, withLastSpacer }: Props) => {
  const title = getActionName(action)

  return (
    <AutomationStep
      action={action}
      disabled={false}
      onClick={onClick}
      stepType={automationSteps.condition}
      withLastSpacer={withLastSpacer}
      title={title}
    >
      <Box paddingX="s16" paddingBottom="s16">
        <FormComponent>{form && <Selects form={form} label={title} />}</FormComponent>
      </Box>
    </AutomationStep>
  )
}

export default observer(TimeAction)
